import { getApiBaseUrl } from "src/utils";

export const getRetmInstallUrl = (token: string): string | null => {
  const base = getApiBaseUrl();
  if (!base) {
    return null;
  }
  return `${base}/api/retm/install?token=${encodeURIComponent(token)}`;
};
